import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Container from '../../layout/container/container';
import Spacing from '../../layout/spacing/spacing';
import Carousel from '../../carousel/carousel';

const MusingCarouselBlock = ({
  paddingTop,
  paddingBottom,
  background,
  ...props
}) => {

  const data = useStaticQuery(graphql`
    query {
      allDatoCmsMusing(sort: {position: ASC}) {
        nodes {
          id: originalId
          readTime
          title
          date(formatString: "D MMM YYYY")
          category
          cardBlurb
        }
      }
    }
  `);

  const musings = data.allDatoCmsMusing.nodes;


  return (
    <Container bg={background} gutters>
      <Spacing pt={paddingTop} pb={paddingBottom}>
        <Carousel cards={musings} {...props} />
      </Spacing>
    </Container>
  );
};

export default MusingCarouselBlock;

export const query = graphql`
  fragment MusingCarouselBlock on DatoCmsMusingCarouselBlock {
    id: originalId
    paddingTop
    paddingBottom
    __typename
  }
`;
